import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import '@babel/polyfill'
import 'roboto-fontface/css/roboto/roboto-fontface.css'
import '@mdi/font/css/materialdesignicons.css'

Vue.config.productionTip = false

new Vue({
  router,
  store,
  vuetify,
  created () {
    this.$store.dispatch('auth/initialize').then(() => {
      this.$store.dispatch('auth/user')
    })
    // this.$store.dispatch('schoolFood/fetchStatuses')
  },
  render: h => h(App)
}).$mount('#app')
